export default __webpack_public_path__ + "static/media/image-ph-health-home-w@2x.48062395.png";